import React from "react";
import {
  Heading,
  Text
} from 'blueprints2';
import { FormattedMessage } from 'react-intl';

function CredentialTableEmpty() {
  return (
    <div className="p-8 bg-gray-100">
      <div className="w-full p-2 text-center">
        <Heading level={3} className="text-purple-600">
          <FormattedMessage id="applications.credentials.empty_heading"/>
        </Heading>
      </div>
      <div className="w-full p-2 text-center">
        <Text>
          <FormattedMessage id="applications.credentials.empty_body"/>
        </Text>
      </div>
    </div>
  )
}

export default CredentialTableEmpty;